import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function MobileApps() {
  return <ServiceDetailPage service={servicePageContent.mobileApps} />;
}
